<template>
  <div class="invoicing-results">
    <main>
      <div v-if="isOpening" :class="`result ${getResultColor}`">
        <template v-if="invoiceResult.status === '1'">
          <i class="allIconFont">&#xe6ce;</i>
          <span>开票成功</span>
          <div class="message">发票已开具成功</div>
        </template>
        <template v-else-if="invoiceResult.status === '2'">
          <i class="allIconFont">&#xe6cf;</i>
          <span>开票失败</span>
          <div class="message">{{ invoiceResult.message }}</div>
        </template>
        <template v-else-if="invoiceResult.status === '0'">
          <i class="allIconFont">&#xe6bc;</i>
          <span>正在开票</span>
          <div class="message">发票正在开具中，请勿操作</div>
        </template>
        <template v-else>
          <i class="allIconFont">&#xe6cf;</i>
          <span>暂无数据</span>
          <div class="message">暂无发票结果</div>
        </template>
      </div>
      <div v-else class="invoice">
        <InvoiceCanvas :invoiceData="{}" ref="invoiceCanvasRef" class="invoicePic"></InvoiceCanvas>
        <ImagePreview @onClose="onPreviewClose" :visible="previewShow" :img="img" />
      </div>
      <div class="btn-list">
        <div>
          <MainButton
            :handleClick="() => handleBtnClick('view')"
          >
            <span>已开发票</span>
          </MainButton>
        </div>
        <div v-if="invoiceResult.status !== '0'">
          <MainButton
            :handleClick="() => handleBtnClick('continue')"
          >
            <span>继续填开</span>
          </MainButton>
        </div>
        <div v-if="!isOpening" class="expand">
          <i class="allIconFont">&#xe670;</i>
        </div>
      </div>
      <Advertisement />
    </main>
  </div>
</template>

<script>
import InvoiceCanvas from '@components/InvoiceCanvas/index.vue'
import MainButton from '@components/MainButton'
import ImagePreview from '@components/ImagePreview'
import { aesDoDecrypt } from '@/utils/basicUtil.js'
import { mapActions, mapState } from 'vuex'
import { Toast } from 'vant'
export default {
  components: {
    [Toast.name]: Toast,
    InvoiceCanvas,
    ImagePreview,
    MainButton
  },
  computed: {
    ...mapState('invoiceOpeningModel', ['invoiceResult']),
    getResultColor () {
      if (this.invoiceResult.status === '0') { // 开具中
        return 'wait'
      }
      if (this.invoiceResult.status === '1') { // 开具成功
        return 'success'
      }
      if (this.invoiceResult.status === '2') { // 开具失败
        return 'error'
      }
      return 'error'
    }
  },
  data () {
    return {
      name: '1',
      img: '',
      previewShow: false,
      timer: null,
      isOpening: true,
      btnFlag: '0' // 0 为不存在按钮 1 存在
    }
  },
  watch: {
    'invoiceResult': {
      handler (val) {
        if (val.status !== '0') {
          clearInterval(this.timer)
        }
      },
      deep: true
    }
  },
  async mounted () {

  },
  async activated () {
    const { flag } = this.$route.query
    // isOpening
    if (flag) {
      this.btnFlag = aesDoDecrypt(flag)
    }
    // this.isOpening = !!(aesDoDecrypt(isOpening))
    try {
      Toast.loading({
        message: '查询结果中...',
        duration: 0
      })
      const res = await this.getInvoiceResult()
      if (res.status === '0') {
        this.pollingGetResult()
      }
    } catch (error) {
    } finally {
      Toast.clear({
        clearAll: true
      })
    }
  },
  methods: {
    ...mapActions('invoiceOpeningModel', ['getInvoiceResult']),
    onShowCanvas (index) {
      let src = this.$refs.invoiceCanvasRef[index].$refs.imgRef.children[0].src
      this.previewShow = true
      this.img = src
    },
    onPreviewClose () {
      this.previewShow = false
    },
    handleBtnClick (type) {
      if (type === 'continue') {
        this.$router.push('/invoice-opening/index')
      } else if (type === 'view') {
        this.$router.push('/invoice-list/index')
      }
    },
    pollingGetResult () {
      this.timer = setInterval(() => {
        this.getInvoiceResult()
      }, 3000)
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
